// Shimmering placeholder block. Pure dumb — caller sets size; module css
// drives the gradient animation. Use `rounded` for avatar-shaped slots.

import styles from './common.module.css'

interface Props {
  width?: number | string
  height?: number | string
  rounded?: boolean
}

export function Skeleton({ width = '100%', height = 16, rounded }: Props) {
  return (
    <span
      className={`${styles.skeleton} ${rounded ? styles.skeletonRound : ''}`}
      style={{ width, height }}
      aria-hidden
    />
  )
}
